<template>
<div :class="isApplication ? 'application-modal' : ''">
    <div class="info-modal-overlay"  @click="close()"></div>    
    <div :class="isApplication ? 'application-container info-modal' : 'info-modal'">
        <div class="info-modal-close-section">
            <!-- <img src="@/assets/close.svg" style="width: 21px;cursor: pointer" @click="close()"> -->
            <inline-svg src="/img/icons/close.svg" width="21" height="21" :fill="this.$store.state.nightMode ? 'white' : 'black'" @click="close()"></inline-svg>
        </div>
        <div style="padding-bottom: 34px;font-weight: bold;font-size: 1.4rem;padding-left: 14px;padding-right: 14px;" v-html="info" v-if="!isApplication">
                
        </div>
        
        <div v-if="isApplication">
<!--            <div>-->
<!--                <iframe width="100%" height="315" src="https://www.youtube.com/embed/nZLJRxWfXAg?controls=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
<!--            </div>-->


            <div style="
    padding: 14px;
    font-size: 1.2rem;
    font-weight: bold;
">
                Завантаж додаток! Отримай 5% кешбеку на перше замовлення та 3% на усі подальші!
            </div>
            <div style="font-weight: bold;display: flex;justify-content: center; align-items:center; padding: 14px;" @click="downloadApp">
                <div v-if="applicationType == 'android'" style="margin-right: 14px;">
                    <img src="@/assets/googleplay.webp" style="width: 120px;">
                </div>
                <div v-if="applicationType == 'ios'" style="margin-right: 14px;">
                    <img src="@/assets/appstore.webp" style="width: 120px;">
                </div>
                <button class="add-to-card-button">Завантажити</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
    components: {
      InlineSvg
    },
    props: ['info', 'isApplication', 'applicationType', 'applicationURL'],
    data() {
        return {
        }
    },

    methods: {
        downloadApp() {
            window.location = this.applicationURL;
        },

        close() {
            this.$emit('close');
        }
    }
}
</script>

<style>
.info-modal-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(70, 70, 70, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}

.info-modal {
    position: absolute;
    width: 90%;
    max-width: 520px;
    background-color: #fff;
    border: 1px solid #eee;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    z-index: 101;
}

@media only screen and (max-width: 767px) {
    .application-modal .info-modal-overlay {
        display: none;
    }

    .dark .application-container {
        box-shadow: 5px 0 15px rgba(255,255,255,0.3);
    }

    .application-container {
        z-index: 101;
        position: fixed;
        top: unset;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);

        width: 100%;
        max-width: 520px;

        padding: 10px 15px;
        border: 0px;

        background-color: #fff;
        border-radius: 0;
        box-shadow: 5px 0 15px rgba(0,0,0,0.3);
    }

    .application-modal .info-modal-close-section {
        position: absolute;
        right: 10px;
        top: 10px;
        padding: 0;

        cursor: pointer;
    }
}

.info-modal-close-section {
    display: flex;
    justify-content: flex-end;
    padding: 14px;
}

.info-modal-title {
    text-align: left;
    padding-left: 14px;
    font-size: 1.4rem;
    font-weight: 700;
}

</style>